import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  BreadcrumbModule,
  EmptyStateModule,
  ModalModule,
  PaginatorModule,
  TableModule,
  StatusModule,
  IconModule,
  ThemingModule,
  ScrollbarModule,
  DropdownModule
} from '@michelin/theme';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { CustomerSetupComponent } from './components/customer-setup/customer-setup.component';
import { CustomerScreenComponent } from './components/customer-screen/customer-screen.component';

@NgModule({
  declarations: [CustomerSetupComponent, CustomerScreenComponent],
  exports: [CustomerSetupComponent, CustomerScreenComponent],
  imports: [
    TableModule,
    BreadcrumbModule,
    EmptyStateModule,
    PaginatorModule,
    CommonModule,
    ModalModule,
    StatusModule,
    IconModule,
    ThemingModule,
    FormsModule,
    ReactiveFormsModule,
    ScrollbarModule,
    DropdownModule,
    SharedModule
  ]
})
export class CustomerModule {}
